export const SERVICIOS = 'GET_SERVICES'
export const USUARIOS = 'GET_USERS'
export const BUSCAR = "BUSCAR_SERVICIO"
export const GETCATS = "GET_CATEGORIES"
export const FILTERCAT = "FILTRAR_POR_CATEGORIA"
export const ORDERALPH = "ORDER_BY_ALPH"
export const ORDERRAT = "ORDER_BY_RATING"
export const RESETORDER = "RESET_ORDER"
export const SERVICIOID = "SERVICIOID"
export const EMPATYSERVICIOID = "EMPATYSERVICIOID"
export const USUARIOID = "USUARIOID"
export const EMPATYUSUARIO = "EMPATYUSUARIO"
export const FAVORITES = "FAVORITES"
export const ELIMINARFAVORITES = "ELIMINARFAVORITES"
export const CLIENTES_BUSCADOS = "CLIENTES_BUSCADOS"
export const PROVEDORES_BUSCADOS = "PROVEDORES_BUSCADOS"
export const SERVICIOS_BUSCADOS = "SERVICIOS_BUSCADOS"
export const CATEGORIAS_BUSCADAS = "CATEGORIAS_BUSCADAS"
export const REVIEWS = "REVIEWS"
export const MIS_SERVICIOS = "MIS_SERVICIOS"
export const ELIMINAR_MISERVICIO = "ELIMINAR_MISERVICIO"
export const EDITAR_MISERVICIO = "EDITAR_MISERVICIO"
export const MIS_CITAS = "MIS_CITAS"
export const MAPSERVICES = 'TRAER_SERVICIOS_MAPA'
export const VER_HORARIOS = 'VER_HORARIOS'
export const ELIMINAR_CITAS = 'ELIMINAR_CITAS'
export const RESERVAS = 'RESERVAS'
export const STATUS_CITA = 'STATUS_CITA'
